import axios from 'axios';

const urlBase = "https://canansanvicente.duckdns.org:8444/servicepool";

export const Http = {
    get:function(url){
        return axios.get(urlBase.concat(url));
    },
    post:function(url, data = null){
        return axios.post(urlBase.concat(url), data, this.getHeaderBasic());
    },
    getHeaderBasic(){
        return {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-type': 'application/json'
            }
        };
    }
};